module.exports = __webpack_public_path__ + "assets/img/help_tj8.c2ab2200.png";